

exports.__esModule = true;

var _squid = require('squid');

var _angular = require('angular');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoOfferTopBanner', {
    tag: 'xo-offer-top-banner',
    template: _template2['default'],
    controller: ['$scope', function ($scope) {
        $scope.isTopBannerVisible = false;
        $scope.offerTopBanner = {};
        $scope.PPClogoBannerURL = 'https://' + _squid.$meta.cdnHost + '/webstatic/credit/img/PPClogo_banner.png';
        // this data comes from an $emit() call in:
        // xo-credit-components/src/offer/directive.js
        var unbind = _angular.$rootScope.$on('setOfferTopBanner', function (event, data) {
            $scope.offerTopBanner = data;
            $scope.isTopBannerVisible = true;
        });

        $scope.$on('$destroy', unbind);
    }]
});


_squid.$Component;

_squid.$meta;

_angular.$rootScope;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-credit-components/src/xo-offer-top-banner/directive.js
// module id = ../node_modules/xo-credit-components/src/xo-offer-top-banner/directive.js
// module chunks = 0